// utils
import React from "react";
import { useMatch } from "react-router-dom";
import Dialog from "../../components/dialog";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";

// custom utils
import {
  getCurrentLanguage,
  getUrlPrefix,
  LANGUAGES,
} from "../../utils/langUtils";

// translations

// files

// page sections
import CybersecHero from "./components/cybersec-hero/cybersec-hero";
import CybersecContact from "./components/cybersec-contact/cybersec-contact";
import CybersecServices from "./components/cybersec-services/cybersec-services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { BtnFloating } from "../../components/btn/btn-floating";
import CybersecOpenCalc from "./components/cybersec-open-calc/cybersec-open-calc";

/**
 * CYBERSEC page
 * Handles whole CYBERSEC page with form - language, required input check, POST to the server as multipart/form-data
 * @returns HTML element for CYBERSEC page with 3 CybersecServices
 */
export default function Index() {

  // solves broken layout of some pages in build
  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }

  return (
    <>
      <div className="fade-in-750">
        <CybersecHero></CybersecHero>
        <CybersecOpenCalc></CybersecOpenCalc>
        <CybersecServices></CybersecServices>
        <CybersecContact></CybersecContact>
      </div>
    </>
  );
}
